import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ExportConsentStatus } from '../../shared/models/export-consent-status.model';
import { UserInformation } from '../../shared/models/user-information.model';

@Injectable()
export class UserService {
  private readonly httpClient = inject(HttpClient);

  private readonly apiUrl = '/api/dealership/user';

  getUserInformation(): Observable<UserInformation> {
    return this.httpClient.get<UserInformation>(this.apiUrl);
  }

  getExportConsent(): Observable<ExportConsentStatus> {
    return this.httpClient.get<ExportConsentStatus>(this.apiUrl + '/export-consent');
  }

  saveExportConsent(): Observable<ExportConsentStatus> {
    return this.httpClient.post<ExportConsentStatus>(this.apiUrl + '/export-consent', {});
  }
}
